import React, { useState } from 'react';
import { Checkbox, Form } from 'components/ds';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { SCHEMA_STORAGE_KEY } from '../../services/SchemaService';
import { CheckboxGroup, FormContainer } from './TermsCheckboxes.styles';
import AcceptTermsModal from '../ModalTerms';
import { getTermsTextConfig } from 'utils/getTermsTextConfig';

const TermsCheckboxes: React.FC = () => {
  const [form] = Form.useForm();
  const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
  const [visibleTermId, setVisibleTermId] = useState<string | null>(null);
  
  const visibleTerm = schema.terms?.find((term: any) => term.id === visibleTermId);
  
  const [checkboxValues, setCheckboxValues] = useState<Record<string, boolean>>({});
  
  const handleAgree = () => {
    if (visibleTermId) {
      const fieldName = `terms_${visibleTermId}`;
      const newValues = {...checkboxValues, [fieldName]: true};
      setCheckboxValues(newValues);
      form.setFieldsValue(newValues);
      setVisibleTermId(null);
    }
  };
  
  const handleClose = () => {
    setVisibleTermId(null);
  };

  // Obter configuração de estilos para o texto dos termos
  const termsTextConfig = getTermsTextConfig();

  return (
    <FormContainer>
      <Form form={form} layout="vertical" onFinish={() => {
      }}>
        <CheckboxGroup>
          {schema.terms?.map((term: any) => {
            const fieldName = `terms_${term.id}`;
            
            return (
              <Form.Item
                key={term.id}
                name={fieldName}
                valuePropName="checked"
                style={{marginBottom: 0}}
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject(
                          new Error(`Você precisa aceitar ${term.title.toLowerCase()}`)
                        )
                  }
                ]}
              >
                <Checkbox
                  checked={checkboxValues[fieldName]}
                  onClick={(e) => {
                    e.preventDefault();
                    setVisibleTermId(term.id);
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                  }}
                >
                  <span style={termsTextConfig}>
                    Li e aceito {term.id === schema.terms[0].id ? 'todos os' : 'os'} {term.title.toLowerCase()}
                  </span>
                </Checkbox>
              </Form.Item>
            );
          })}
        </CheckboxGroup>
        
        {visibleTerm && (
          <AcceptTermsModal
            visible
            onClose={handleClose}
            onAgree={handleAgree}
            urlPDF={visibleTerm.contentUrl || ''}
            title={visibleTerm.title}
            message={`Li e aceito o ${visibleTerm.title.toLowerCase()}`}
          />
        )}
      </Form>
    </FormContainer>
  );
};

export default TermsCheckboxes;
